import { decodeJwt } from 'jose';

const generateCsrfToken = () => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return Array.from(array).map(b => b.toString(16).padStart(2, '0')).join('');
};

const safeJsonParse = (key, fallback = {}) => {
  try {
    return JSON.parse(sessionStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
};

// Has a token (used during the callback exchange flow only)
export const hasToken = () => {
  const authStore = safeJsonParse('authStore');
  return !!authStore?.access_token;
};

// Fully verified by Apollo JWT check — this is the real auth gate
export const isAuthenticated = () => {
  return sessionStorage.getItem('auth_verified') === 'true';
};

export const setAuthVerified = () => {
  sessionStorage.setItem('auth_verified', 'true');
};

export const clearAuthVerified = () => {
  sessionStorage.removeItem('auth_verified');
};

export const getSessionStore = () => {
  return safeJsonParse('sessionStore');
};

export const setSessionStore = (data) => {
  const store = getSessionStore();
  const newStore = Object.assign(store, data);
  sessionStorage.setItem('sessionStore', JSON.stringify(newStore));
};

// Claims are decoded from the access token — session_state, preferred_username,
// sid, cid, exp, etc. are all available here without storing them separately.
export const getClaims = () => {
  try {
    const authStore = safeJsonParse('authStore');
    const access_token = authStore?.access_token;
    return access_token ? decodeJwt(access_token) : {};
  } catch {
    return {};
  }
};

export const getAuthStore = () => {
  return safeJsonParse('authStore');
};

export const getLogoutCsrf = () => {
  return sessionStorage.getItem('logout_csrf');
};

// Stores only { access_token, refresh_token, id_token } — the three fields
// the portal needs. All other Keycloak response fields (expires_in, token_type,
// scope, session_state, not-before-policy) are discarded at the call site
// in exchangeCodeForToken before reaching here.
export const setAuthStore = (auth) => {
  try {
    const logout_csrf = generateCsrfToken();
    sessionStorage.setItem('logout_csrf', logout_csrf);
    sessionStorage.setItem('authStore', JSON.stringify(auth));
  } catch {
    console.error('Failed to set authStore');
  }
};

export const resetSessionStore = () => {
  sessionStorage.removeItem('sessionStore');
};

export const resetAuthStore = () => {
  sessionStorage.removeItem('authStore');
  sessionStorage.removeItem('auth_verified');
  localStorage.removeItem('agreement');
};

export const getRefreshToken = () => {
  const authStore = safeJsonParse('authStore');
  return authStore?.refresh_token || null;
};
